module.exports = __webpack_public_path__ + "img/paul_s_2.dd02c227.png";